import { ExternalLink } from 'lucide-react';

import { Button } from '@/components/ui/button';
import type { ITodayOffersForRequest } from '@/pages/PurchasesContainer/PurchasesRequests/api/Request.interface';

type Props = {
  row: ITodayOffersForRequest;
  OneOfferSelectForPrepareFn: (newValue: ITodayOffersForRequest) => void;
};

function ActionCol({ row, OneOfferSelectForPrepareFn }: Props) {
  return (
    <div className="text-large flex w-full items-center justify-center font-beiruti">
      <Button
        variant="outline"
        size="icon"
        onClick={OneOfferSelectForPrepareFn.bind(null, row)}
      >
        <ExternalLink />
      </Button>
    </div>
  );
}

export default ActionCol;
